import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import User from './user';
import Users from './users';
import Questionnaires from './questionnaires';
import TrainingModules from './trainingModules';
import TrophySettings from './trophySettings';
import BreathingRhythm from './breathingRhythm';
import AssessmentTest from './assessmentTest';
import RpeScale from './rpeScale';
import EnduranceActivity from  './enduranceActivity';
import SideEffect from './nutrition/sideEffects';
import Exercise from './treatmentPlanning/exercise';
import Pt from './treatmentPlanning/progressionTable';
import Recipe from './nutrition/recipe';
import Physician from './physician';


export default combineReducers({
    router: routerReducer,
    user: User,
    users: Users,
    questionnaires: Questionnaires,
    trainingModules: TrainingModules,
    trophySettings: TrophySettings,
    breathingRhythm: BreathingRhythm,
    assessmentTest: AssessmentTest,
    rpeScale: RpeScale,
    enduranceActivity: EnduranceActivity,
    sideEffect: SideEffect,
    exercise: Exercise,
    pt: Pt,
    recipe: Recipe,
    physician: Physician,
});
